import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class Iframe extends Component {

  render() {
    const { tellRef, src, title, className, ...props } = this.props;
    return (
      <iframe
        src={src}
        title={title}
        ref={tellRef}
        className={classNames('zf-iframe', className)}
        {...props}
      >
      </iframe>
    );
  }

}

Iframe.propTypes = {
  className: PropTypes.string,
  src: PropTypes.string.isRequired,
  title: PropTypes.string,
  tellRef: PropTypes.func
};

export default Iframe;
